/*
 *  Метод сколнения существительных стоящих радом с числительным в зависмости от значения этого числа
 *  на ввод подаем:
 *   - цело число
 *   - массив существиельных в нужной форме напр. [' товар', ' товара', ' товаров']
 */

const declOfNum = function (number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[
        number % 100 > 4 && number % 100 < 20
            ? 2
            : cases[number % 10 < 5 ? number % 10 : 5]
    ];
};

export { declOfNum };
